
export default function VehiclesSection() {
  const vehicles = [
    {
      type: 'Sedán Ejecutivo',
      capacity: '1-3 pasajeros',
      luggage: '3 maletas',
      image: 'https://public.readdy.ai/ai/img_res/32cf8e417a986010f39e4d96023cfbf6.jpg',
      features: ['Aire acondicionado', 'Asientos de cuero', 'WiFi gratuito', 'Agua embotellada'],
      price: 'Desde $450 MXN'
    },
    {
      type: 'Van para 8 Pasajeros',
      capacity: '4-8 pasajeros',
      luggage: '8 maletas',
      image: 'https://readdy.ai/api/search-image?query=White%20SUV%20family%20vehicle%20for%20airport%20transfers%20in%20tropical%20Mexican%20setting%2C%20spacious%20comfortable%20SUV%20with%20open%20doors%20showing%20interior%2C%20parked%20at%20beautiful%20Zihuatanejo%20location%20with%20ocean%20view%20background%2C%20professional%20transportation%20service%20photography%2C%20clean%20modern%20vehicle&width=600&height=400&seq=suv-family&orientation=landscape',
      features: ['Espacio amplio', 'Asientos cómodos', 'Sistema de entretenimiento', 'Cargadores USB'],
      price: 'Desde $650 MXN'
    },
    {
      type: 'Van para 10 Pasajeros',
      capacity: '7-10 pasajeros',
      luggage: '10 maletas',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20white%20passenger%20van%20for%20group%20transportation%20in%20Zihuatanejo%20Mexico%2C%20spacious%20comfortable%20van%20with%20multiple%20rows%20of%20seating%2C%20professional%20airport%20transfer%20vehicle%20parked%20at%20scenic%20coastal%20location%2C%20high-quality%20transportation%20service%20photography&width=600&height=400&seq=van-luxury&orientation=landscape',
      features: ['Múltiples filas', 'Aire acondicionado dual', 'Sonido premium', 'Espacio extra'],
      price: 'Desde $950 MXN'
    },
    {
      type: 'Camioneta Grupo',
      capacity: '13-15 pasajeros',
      luggage: '15 maletas',
      image: 'https://readdy.ai/api/search-image?query=Large%20passenger%20shuttle%20van%20for%20big%20groups%20in%20Mexico%2C%20professional%20group%20transportation%20vehicle%20with%20multiple%20windows%2C%20comfortable%20seating%20for%2015%20people%2C%20parked%20at%20Zihuatanejo%20airport%20or%20hotel%20area%2C%20commercial%20transportation%20photography%20style&width=600&height=400&seq=shuttle-group&orientation=landscape',
      features: ['Capacidad máxima', 'Entrada fácil', 'Compartimentos equipaje', 'Conductor profesional'],
      price: 'Desde $1,200 MXN'
    }
  ];

  return (
    <section id="vehiculos" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nuestra Flota de Vehículos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Contamos con una flota moderna y bien mantenida para satisfacer las 
            necesidades de cualquier grupo, desde viajeros individuales hasta grupos grandes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {vehicles.map((vehicle, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-64">
                <img 
                  src={vehicle.image}
                  alt={vehicle.type}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {vehicle.price}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{vehicle.type}</h3>
                <div className="flex items-center gap-6 mb-4 text-gray-600">
                  <div className="flex items-center">
                    <i className="ri-user-line mr-2 text-blue-600"></i>
                    <span>{vehicle.capacity}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-suitcase-line mr-2 text-blue-600"></i>
                    <span>{vehicle.luggage}</span>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-2 mb-6">
                  {vehicle.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-green-600 mr-2"></i>
                      {feature}
                    </div>
                  ))}
                </div>
                
                <button 
                  onClick={() => window.open('https://wa.me/527551234567?text=Hola, me interesa el ' + vehicle.type, '_blank')}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  Reservar {vehicle.type}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-blue-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Todos Nuestros Vehículos Incluyen</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-shield-check-line text-3xl"></i>
              </div>
              <h4 className="font-semibold mb-2">Seguro Completo</h4>
              <p className="text-sm text-teal-100">Cobertura total para tu tranquilidad</p>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-user-star-line text-3xl"></i>
              </div>
              <h4 className="font-semibold mb-2">Conductor Profesional</h4>
              <p className="text-sm text-teal-100">Experiencia y conocimiento local</p>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-tools-line text-3xl"></i>
              </div>
              <h4 className="font-semibold mb-2">Mantenimiento</h4>
              <p className="text-sm text-teal-100">Vehículos en perfectas condiciones</p>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-customer-service-2-line text-3xl"></i>
              </div>
              <h4 className="font-semibold mb-2">Soporte 24/7</h4>
              <p className="text-sm text-teal-100">Asistencia en todo momento</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
